import { useEffect, useState } from 'react';
import PeopleContent from './PeopleContent';
import classNames from '@/lib/misc/classNames';
export default function FeedPeople({
  className
}: {
  className?: string;
}) {
  const [isCLient, setIsCLient] = useState(false);
  useEffect(() => {
    setIsCLient(true);
  }, []);
  if (!isCLient) {
    return;
  }
  return <div className={classNames(`genius-shadow mb-4 pb-4 items-center bg-genius-indigo rounded-[20px] border-genius-blue border-[1px] overflow-hidden h-[751px] mt-4`, className)} data-sentry-component="FeedPeople" data-sentry-source-file="FeedPeople.tsx">
      <div className='mt-4 pb-2 h-full'>
        <PeopleContent data-sentry-element="PeopleContent" data-sentry-source-file="FeedPeople.tsx" />
      </div>
    </div>;
}